const data = {
  title: 'Hoteles en el estado',

  elements: [
    {
      id: '1',
      url: '/hoteles/economicos/global',
      title: 'Los Hoteles más Económicos',
    },
    {
      id: '2',
      url: '/hoteles/grandes/global',
      title: 'Los Hoteles más Grandes',
    },
  ],
}

export default data
